import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';
import { Reference } from '@apollo/client';


export const Folder: ITypeSpecificPolicy<types.Folder> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy(),
    updatedTimestamp: dateTimeFieldPolicy(),
    fileCount: {
      read: (existing, { readField }) => {
        const documents = readField<Reference[]>('documents');
        const folderId = readField('id');
        const filteredDocs = documents?.filter((node) => {
          const folderRef = readField<Reference | null>('folder', node);
          if (!folderRef) {
            return false;
          }
          const id = readField('id', folderRef);
          return folderId === id;
        });
        return filteredDocs?.length ?? 0;

      },
      merge: true
    }
  }
};
